import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { NavigateToUrlDirective } from '@core/directive/navigate-to-url/navigate-to-url.directive';
import { MenuItemLinkType } from '../../../../utils/enum/menu-item-link-type.enum';
import { IMenuItemLink } from '@utils/interfaces/menu-item-link.model';

@Component({
  selector: 'app-sub-menu',
  templateUrl: './sub-menu.component.html',
  styleUrls: ['./sub-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,

  imports: [RouterModule, MatIconModule, NavigateToUrlDirective]
})
export class SubMenuComponent {
  @Input() items!: IMenuItemLink[];

  MenuItemType: typeof MenuItemLinkType = MenuItemLinkType;
}
